<i18n
  src="@/locales/views/organization/partners/producers/list_producers.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/producer.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/crop_field.yml" lang="yaml"></i18n>
<template>
  <!-- <div class="pt-6">
    <nav class="flex flex-col sm:flex-row border-b border-blue-300">
        <button class="text-gray-600 py-4 px-6 -m-0.5 block hover:text-blue-500 focus:outline-none text-blue-500 border-b-2 font-medium border-blue-500">
            Formalizados (545)
        </button>
        <button class="text-gray-600 py-4 px-6 block hover:text-blue-500 focus:outline-none">
            No formalizados (10)
        </button><button class="text-gray-600 py-4 px-6 block hover:text-blue-500 focus:outline-none">
            Inactivos (0)
        </button>
    </nav>
</div> -->
  <div v-if="load_data_general">
    <div class="mt-8 flex flex-row justify-between">
      <div class="panel-plain-label space-x-2">
        <badge-default
          :label="total_producers + ' ' + $t('labels.total_number_producers')"
        />
        <badge-default
          :label="total_hectares + ' ' + $t('labels.total_hectares')"
        />
        <badge-default
          :label="total_square_meters + ' ' + $t('labels.total_square_meters')"
        />
      </div>

      <div>
        <button
          v-if="producers.length > 0"
          type="button"
          @click.prevent="downloadRepCropFieldsXlsx()"
          class="btn-white"
        >
          <i
            :class="[
              'fa-solid',
              downloading_crop_field ? 'fa-sync fa-spin' : 'fa-file-excel'
            ]"
          ></i
          ><span class="space-icon"></span
          >{{ $t("labels.download_crop_fields_report_button") }}
        </button>
        <span class="space-actions" />
        <button
          v-if="producers.length > 0"
          type="button"
          @click.prevent="downloadRepProducersXlsx()"
          class="btn-white"
        >
          <i
            :class="[
              'fa-solid',
              downloading ? 'fa-sync fa-spin' : 'fa-file-excel'
            ]"
          ></i
          ><span class="space-icon"></span
          >{{ $t("labels.download_producers_report_button") }}
        </button>
        <span class="space-actions" />
        <new-button
          @click.prevent="goToNewProducer"
          :label="$t('labels.new_producer_button')"
        />
      </div>
    </div>
    <div class="mt-4 flex flex-row-reverse gap-2">
      <white-button v-if="filtered" label="Limpiar" @click="clearFilters" />
      <white-button
        label="Filtrar"
        @click="filterProducers"
      />
      <input
        type="text"
        v-model.trim="filters.producer_code"
        :placeholder="$t('model.producer.producer_code')"
        class="shadow-sm focus:ring-lime-500 focus:border-lime-500 block sm:text-sm border-gray-300 rounded-md"
      />
      <input
        type="text"
        v-model.trim="filters.organization_producer_code"
        :placeholder="$t('model.producer.organization_producer.producer_code')"
        class="shadow-sm focus:ring-lime-500 focus:border-lime-500 block sm:text-sm border-gray-300 rounded-md"
      />
    </div>
    <div class="mt-4 flex flex-col">
      <ag-grid-vue
        v-if="producers.length > 0"
        style="width: 100%; height: 550px"
        class="ag-theme-alpine w-full h-full"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="producers"
        @grid-ready="onGridReady"
        @filter-changed="onFilterChanged"
        @filter-modified="onFilterModified"
      >
      </ag-grid-vue>
      <alert-warning
        class="mt-8"
        v-else
        :warning_data="{
          title: $t('labels.no_producers_found')
        }"
      />
    </div>
  </div>

  <loading-message v-else />

  <letter-paginator
    v-if="load_data_general"
    v-show="!filtered"
    v-model="current_page"
  />
</template>

<script>
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue3";
import LetterPaginator from "@/components/views/layout/LetterPaginator.vue";
import Requester from "@/views/organization/requesters/partners/producers/list_producers.js";
import GoToLink from "@/components/views/layout/ag_grid/GoToLink.vue";

export default {
  name: "OrgPartnersProducersListProducersFormalizedActive",
  components: { AgGridVue, LetterPaginator },
  data() {
    return {
      load_data_general: false,
      downloading: false,
      downloading_crop_field: false,
      filtering: false,
      filtered: false,
      producers: this.producers_formalized_active,
      total_hectares: 0,
      total_square_meters: 0,
      current_page: "A",
      total_producers: 0,
      rows_per_page: 10,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        filter: true,
        floatingFilter: false
      },
      columnDefs: [
        {
          headerName: this.$t(
            "model.producer.organization_producer.producer_code"
          ),
          field: "organization_producer.producer_code",
          filter: true,
          cellRendererSelector: params => {
            return {
              component: GoToLink,
              params: {
                text: params.value,
                path_name: "org_partners_producers_show_producer_path",
                params_path: {
                  organization_id: this.organization_id,
                  producer_id: params.data.id
                }
              }
            };
          }
        },
        {
          headerName: this.$t("model.producer.producer_code"),
          field: "producer_code",
          filter: true,
          cellRendererSelector: params => {
            return {
              component: GoToLink,
              params: {
                text: params.value || "-",
                path_name: "org_partners_producers_show_producer_path",
                params_path: {
                  organization_id: this.organization_id,
                  producer_id: params.data.id
                }
              }
            };
          }
        },
        {
          headerName: this.$t("model.producer.lastname"),
          field: "lastname",
          filter: true,
          width: 300
        },
        {
          headerName: this.$t("model.producer.name"),
          field: "name",
          filter: true,
          width: 300
        },
        {
          headerName: this.$t("model.producer.producer_crops"),
          filter: true,
          valueGetter: params => {
            return params.data.producer_crops
              .map(pc => pc.crop.name)
              .join(", ");
          }
        },
        {
          headerName: this.$t("model.crop_field.hectares"),
          field: "hectares",
          filter: "agNumberColumnFilter",
          valueFormatter: params => {
            return this.numberWithPrecision(params.value);
          }
        },
        {
          headerName: this.$t("model.crop_field.square_meters"),
          field: "square_meters",
          filter: "agNumberColumnFilter",
          valueFormatter: params => {
            return this.numberWithPrecision(params.value);
          }
        }
      ],
      menu_items: [
        {
          label: this.$t("labels.download_producers_report_button"),
          action: () => this.downloadRepProducersXlsx()
        },
        {
          label: this.$t("labels.download_crop_fields_report_button"),
          action: () => this.downloadRepCropFieldsXlsx()
        }
      ],
      filters: {
        organization_producer_code: "",
        producer_code: ""
      }
    };
  },
  props: {
    organization_id: {
      required: true
    },
    producers_formalized_active: null,
    producers_formalized_active_page: { type: Number, default: 1 }
  },
  computed: {
    can_filter() {
      return Object.values(this.filters).some(f => f !== "");
    }
  },
  watch: {
    current_page: async function (current_page) {
      await this.fetchProducers();
      this.$emit("update:producers_formalized_active_page", current_page);
    }
  },
  methods: {
    fetchProducers: async function () {
      let response = await Requester.fetchProducersFormalizedActive(
        this.organization_id,
        this.current_page,
        this.rows_per_page
      );
      this.producers = response.data.producers;
      this.total_producers = response.data.total;
      this.total_hectares =
        this.numberWithPrecision(response.data.total_hectares) || 0;
      this.total_square_meters =
        this.numberWithPrecision(response.data.total_square_meters) || 0;
      this.$emit("update:producers_formalized_active", this.producers);
      this.load_data_general = true;
    },
    filterProducers: async function () {
      if (!this.filtering && this.can_filter) {
        let response = await Requester.filterProducersFormalizedActive(
          this.organization_id,
          this.filters
        );
        this.producers = response.data;
        this.filtered = true;
      }
    },
    clearFilters() {
      this.filters = {
        organization_producer_code: "",
        producer_code: ""
      };
      this.filtered = false;
      this.producers = this.producers_formalized_active;
    },
    downloadRepProducersXlsx: async function () {
      this.downloading = true;
      try {
        var response = await Requester.downloadRepProducersFormalizedActiveXlsx(
          this.organization_id
        );
        const file = response.data;

        this.downloadFile(file, "Productores_formalizados.xlsx");
      } catch (error) {
        error;
      }
      this.downloading = false;
    },
    downloadRepCropFieldsXlsx: async function () {
      this.downloading_crop_field = true;
      try {
        var response =
          await Requester.downloadRepCropFieldsFormalizedActiveXlsx(
            this.organization_id
          );
        const file = response.data;
        this.downloadFile(file, "Productores_formalizados_y_campos.xlsx");
      } catch (error) {
        error;
      }
      this.downloading_crop_field = false;
    },
    goToNewProducer: function () {
      this.$router.push({
        name: this.routeName("new_producer"),
        params: {
          organization_id: this.organization_id
        }
      });
    },
    sizeToFit() {
      this.gridApi.sizeColumnsToFit({
        defaultMinWidth: 150
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.sizeToFit();
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => this.fetchProducers())
    );
  }
};
</script>
